export class RCReactionValues {

  static UNDEFINED = -1;
  static BAD = 0;
  static NOT_BAD = 1;
  static GOOD = 2;
}
